import { useSelector } from "react-redux";

export const MenuHeader = () => {

    const { imgUrl } = useSelector((state) => state.auth);

    return (
        <div className="w-auto h-[116px] ">
            {/* <img className="w-full absolute top-0 z-100" src={backgrounds.Ellipse} alt="Ellipse" /> */}
            <div className="w-full h-[82px] pt-[22px] px-7 pb-[10px] absolute top-0 z-10">
                <div className="">
                    <img src={imgUrl} alt="Logo de empresa"
                        className="w-[176px] h-[56px] object-contain z-20" />
                </div>
            </div>
        </div>
    );
};
